import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { breakpoints, pxToRelative, pxToRems } from '@awaze/design-system.utils.react';
import styled from 'styled-components';
import { BaseGrid, BaseGridItem, } from '@awaze/design-system.components.base-grid';
import { Heading } from './heading';
import { Text } from './text';
const SideBySideStyled = styled.article `
  line-height: ${({ theme }) => pxToRelative(theme.FontTextText300LineHeight)};
  color: ${({ theme }) => pxToRems(theme.ColorThemeSecondary700)};
  margin-bottom: 48px;

  @media screen and (max-width: ${breakpoints[0]}px) {
    margin-bottom: 24px;

    > :first-child {
      margin-bottom: 16px;
    }
  }
`;
/**
 * A wrapper component to align a heading and text next to eachother.
 */
export const SideBySide = ({ text, heading, columnSplit = [3, 9], }) => {
    return (_jsx(SideBySideStyled, { children: _jsxs(BaseGrid, { flush: true, children: [_jsx(BaseGridItem, { columns: [12, columnSplit[0]], children: _jsx(Heading, { mb: 16, as: heading.as ? heading.as : 'h2', sizes: heading.sizes ? heading.sizes : 100, children: heading.text }) }), _jsx(BaseGridItem, { columns: [12, columnSplit[1]], children: _jsx(Text, { as: text.as ? text.as : 'div', type: "regular", sizes: text.sizes ? text.sizes : 300, children: text.text }) })] }) }));
};
//# sourceMappingURL=side-by-side.js.map